<template>
  <div>
    <div class="flex flex-col items-center mb-6">
      <div class="px-4 mb-6">
        <img
          alt="..."
          class="shadow rounded max-w-full h-auto align-middle border-none"
          :src="user.avatar"
          style="width: 150px;"
        />
      </div>
    </div>
    <div class="flex gap-6">
      <div class="flex w-1/2 flex-col">
        <form-item label='Full Name'>
          <template v-slot>
            <p class="text-left font-bold">{{ user.name }}</p>
          </template>
        </form-item>
        <form-item label='Email'>
          <template v-slot>
            <p class="text-left font-bold">{{ user.email }}</p>
          </template>
        </form-item>
        <form-item label='Birthdate' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <p class="text-left font-bold">{{ user.dob || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Bio' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <div class="flex flex-col">
              <p class="text-left font-bold">{{user.bio_status == 1? (user.biodata || '-') : user.bio }} </p>
              <span v-bind:class="user.bio_status == 1? 'text-green-600 bg-green-200' : 'text-orange-600 bg-orange-200'" class="text-xs text-center font-semibold inline-block py-1 px-2 uppercase rounded uppercase last:mr-0 mr-1 w-64">{{user.bio_status == 1?'Published':'Waiting for Review'}}</span>
            </div>
          </template>
        </form-item>
        <form-item label='Total Earning' v-if="isDetailArtis">
          <template v-slot>
            <p class="text-left font-bold">${{ parseFloat(user.earning).toFixed(2) || 0 }}</p>
          </template>
        </form-item>
        <form-item label='Balance' v-if="isDetailArtis">
          <template v-slot>
            <p class="text-left font-bold">${{ parseFloat(user.balance).toFixed(2) || 0 }}</p>
          </template>
        </form-item>
        <form-item label='MusicVerse Cut' v-if="isDetailArtis">
          <template v-slot>
            <p class="text-left font-bold" v-if="!isEditCalculation">{{ user.musicverse_cut || '-' }}</p>
            <Input
              v-if="isEditCalculation"
              v-model="inputCalc.musicverse_cut"
              placeholder="ex. Video Name"
              :error="$v.input.musicverse_cut.$dirty && (!$v.inputCalc.musicverse_cut.required || !$v.inputCalc.musicverse_cut.numeric)"
              maxlength="100"
              v-on:keyup="changeValueMVCut($event)"
            />
            <div class="flex flex-col pt-2" v-if="isEditCalculation">
              <text-error v-if="$v.inputCalc.musicverse_cut.$dirty && !$v.inputCalc.musicverse_cut.required" text="Please fill MusicVerse Cut." />
              <text-error v-if="$v.inputCalc.musicverse_cut.$dirty && !$v.inputCalc.musicverse_cut.numeric" text="Must be numeric." />
            </div>
          </template>
        </form-item>
        <form-item label='Artist Cut' v-if="isDetailArtis">
          <template v-slot>
            <p class="text-left font-bold" v-if="!isEditCalculation">{{ user.artist_cut || '-' }}</p>
            <Input
              v-if="isEditCalculation"
              v-model="inputCalc.artist_cut"
              placeholder="ex. Video Name"
              :error="$v.input.artist_cut.$dirty && (!$v.inputCalc.artist_cut.required || !$v.inputCalc.artist_cut.numeric)"
              maxlength="100"
              v-on:keyup="changeValueArtistCut($event)"
            />
            <div class="flex flex-col pt-2" v-if="isEditCalculation">
              <text-error v-if="$v.inputCalc.artist_cut.$dirty && !$v.inputCalc.artist_cut.required" text="Please fill Artist Cut." />
              <text-error v-if="$v.inputCalc.artist_cut.$dirty && !$v.inputCalc.artist_cut.numeric" text="Must be numeric." />
            </div>
          </template>
        </form-item>
        <form-item  v-if="isDetailArtis && isEditCalculation && !validCal">
          <template v-slot>
            <text-error text="Maximum Total Calculation is 100 " />
          </template>
        </form-item>
        <div class="flex flex-col md:flex-row" v-if="isDetailArtis && (isAdmin || isSuperAdmin || isOps)">
          <Button v-if="isEditCalculation" @clicked="toggleEditCalculation" variant="default" :label="labelToggleCalc" />
          <Button v-if="!isEditCalculation" @clicked="toggleEditCalculation" variant="primary" :label="labelToggleCalc" />
          <Button v-if="isEditCalculation" @clicked="saveCalc" :disabled="isLoading && validCal" variant="primary" label="Save" />
        </div>
      </div>
      <div class="flex w-1/2 flex-col">
        <form-item label='Bank Name' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <p class="text-left font-bold">{{ user.bank.bank || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Account Name' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <p class="text-left font-bold">{{ user.bank.account_name || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Account Number' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <p class="text-left font-bold">{{ user.bank.account_number || '-' }}</p>
          </template>
        </form-item>
        <form-item label='Swift Code' v-show="isArtist || (isDetailArtis && (isAdmin || isSuperAdmin || isOps))">
          <template v-slot>
            <p class="text-left font-bold">{{ user.bank.swift_code || '-' }}</p>
          </template>
        </form-item>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';

export default {
  name: 'ViewProfile',
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      default: () => ({
        name: '',
        email: '',
        dob: '',
        bio: '',
        genre: '',
        avatar: '',
        bio_status: '',
        bank: {
          bank: '',
          account_name: '',
          account_number: '',
        },
        musicverse_cut: 0,
        artist_cut: 0,
      }),
    },
    isDetailArtis: {
      type: Boolean,
      default: () => (false),
    },
  },
  data() {
    return {
      isEditCalculation: false,
      inputCalc: {
        musicverse_cut: 0,
        artist_cut: 0,
      },
      totalCalc: 0,
    };
  },
  validations: {
    inputCalc: {
      musicverse_cut: {
        required,
        numeric,
      },
      artist_cut: {
        required,
        numeric,
      },
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['isAdmin', 'isFinance', 'isSuperAdmin', 'isOps', 'isArtist', 'isReviewer', 'isReviewer']),
    validCal() {
      // eslint-disable-next-line radix
      const total = parseInt(this.inputCalc.musicverse_cut) + parseInt(this.inputCalc.artist_cut);
      return total > 0 && total <= 100;
    },
    labelToggleCalc() {
      return this.isEditCalculation ? 'Cancel Edit' : 'Edit Calculation';
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.bank === null || val.bank === undefined) {
          this.user.bank = Object.assign({}, {
            bank: '',
            account_name: '',
            account_number: '',
            swift_code: '',
          });
        }
        this.inputCalc.musicverse_cut = val.musicverse_cut;
        this.inputCalc.artist_cut = val.artist_cut;
      },
    },
  },
  methods: {
    ...mapActions('ArtistModule', ['requestUpdateCutCalculation']),
    toggleEditCalculation() {
      this.isEditCalculation = !this.isEditCalculation;
      if (this.isEditCalculation) {
        this.inputCalc.musicverse_cut = this.user.musicverse_cut;
        this.inputCalc.artist_cut = this.user.artist_cut;
      }
    },
    changeValueMVCut(event) {
      if (!isNaN(event.target.value)) {
        this.inputCalc.artist_cut = 100 - event.target.value;
        if (this.inputCalc.artist_cut < 0) {
          this.inputCalc.artist_cut = 0;
        }
      } else {
        this.inputCalc.artist_cut = 100;
        this.inputCalc.musicverse_cut = 0;
      }
    },
    changeValueArtistCut(event) {
      if (!isNaN(event.target.value)) {
        this.inputCalc.musicverse_cut = 100 - event.target.value;
        if (this.inputCalc.musicverse_cut < 0) {
          this.inputCalc.musicverse_cut = 0;
        }
      } else {
        this.inputCalc.musicverse_cut = 100;
        this.inputCalc.artist_cut = 0;
      }
    },
    async saveCalc() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const cutData = {
            id: this.user.id,
            musicverse_cut: this.inputCalc.musicverse_cut,
            artist_cut: this.inputCalc.artist_cut,
          };
          await this.requestUpdateCutCalculation(cutData);
          this.user.musicverse_cut = this.inputCalc.musicverse_cut;
          this.user.artist_cut = this.inputCalc.artist_cut;
          this.toggleEditCalculation();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
  },
  components: { Button, FormItem, Input, TextError },
};
</script>
<style scoped>
.user-avatar{
  width:100px;
  height:100px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/ViewProfile.vue